import * as type from './types'

export function fetchDownloadData(data) {
    return {
        type : type.FETCH_DOWNLOAD_DATA,
        payload : data
    };
}

export function fetchedDownloadData() {
    return {
        type : type.FETCHED_DOWNLOAD_DATA,
    };
}

export function fetchDownloadDataWcWi(data) {
    return {
        type : type.FETCH_DOWNLOAD_DATA_WC_WI,
        payload : data
    };
}

export function fetchedDownloadDataWcWi() {
    return {
        type : type.FETCHED_DOWNLOAD_DATA_WC_WI,
    };
}